import type { SVGProps } from "react";
export interface DispenserMedicalIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function DispenserMedicalIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: DispenserMedicalIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M11.624 13.5c0 .622-.503 1.126-1.125 1.126H9.125v.75H10.5c.622 0 1.125.503 1.125 1.124v1.375h.75V16.5c0-.62.504-1.124 1.125-1.124h1.376v-.75H13.5c-.62 0-1.124-.505-1.125-1.125v-1.376h-.75zm3-1.124h.877c.897 0 1.624.727 1.624 1.624v2c0 .897-.727 1.625-1.624 1.625h-.877v.875c0 .898-.726 1.625-1.624 1.625h-2A1.625 1.625 0 0 1 9.376 18.5v-.875H8.5A1.625 1.625 0 0 1 6.875 16v-2c0-.898.728-1.624 1.625-1.624h.875v-.877c0-.897.728-1.624 1.626-1.624H13c.897 0 1.624.727 1.624 1.624zM15.625 8a1.125 1.125 0 0 1-2.25 0v-.875h-2.75V8a1.125 1.125 0 0 1-2.25 0V6.5c0-.897.728-1.625 1.625-1.625h.874v-1.75H9.266l-1.764.882a1.125 1.125 0 0 1-1.004-2.013l1.894-.948.172-.074c.177-.064.365-.097.554-.097H15a1.125 1.125 0 0 1 0 2.25h-1.875v1.75h.877c.897 0 1.624.728 1.624 1.625V8Z"
      />
      <path
        fill={color}
        d="M17.875 13A3.875 3.875 0 0 0 14 9.124h-4a3.875 3.875 0 0 0-3.875 3.874v6c0 1.036.84 1.876 1.875 1.876h8c1.035 0 1.875-.84 1.875-1.875zm2.25 6a4.125 4.125 0 0 1-4.126 4.125H8A4.125 4.125 0 0 1 3.875 19v-6A6.125 6.125 0 0 1 10 6.874h4a6.125 6.125 0 0 1 6.125 6.124v6Z"
      />
    </svg>
  );
}
